import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Button, Col, Divider, Form, Row, Switch } from 'antd';
import { fetchAditionalConfig, SaveAdditionalConfigurationRegisterForm } from '../../../../../api/repositoryEP';
import LoadingDataComponent from '../../../../common/LoadingData/LoadingDataComponent';

const AddittionalConfigurationComponent = (): JSX.Element => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingConfig, setLoadingConfig] = useState<boolean>(false);
    const [hasVerificationCode, setHasVerificationCode] = useState<boolean>(false);

    const [form] = Form.useForm();

    // Cargar configuración inicial
    useEffect(() => {
        setLoadingConfig(true);
        fetchAditionalConfig().then((r) => {

            if (r?.type === 1) {

                setHasVerificationCode(r.data.hasVerificationCode);
                form.setFieldsValue({ hasVerificationCode: r.data.hasVerificationCode });
            }
            setLoadingConfig(false);
        });
    }, [form]);

    // Watch del switch
    const hasVerificationCodeValue = Form.useWatch("hasVerificationCode", form);

    const onFinish = (values: any) => {
        setLoading(true);
        SaveAdditionalConfigurationRegisterForm(values.hasVerificationCode).then((r) => {
            if (r?.type === 1 && r.data === true) {
                setHasVerificationCode(values.hasVerificationCode);
                form.setFieldsValue({ hasVerificationCode: values.hasVerificationCode });
            }
            setLoading(false);
        });
    };

    return (
        <div className="">
            <Row>
                <Col xs={24} md={24}>
                    <h3>{t('components.tab-configuration.register-form.additional-configuration')}</h3>
                </Col>

                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Col xs={24} md={24}>
                        <Form.Item
                            name="hasVerificationCode"
                            valuePropName="checked"
                            label={t('components.tab-configuration.register-form.has-verification-code')}
                        >
                            <Switch disabled={loadingConfig} className="app-switch" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={8}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="app-button"
                            disabled={loading || hasVerificationCodeValue === hasVerificationCode}
                            loading={loading}
                        >
                            {t('button.save')}
                        </Button>
                    </Col>
                </Form>
                <Divider />





            </Row>
        </div>
    );
};

export default AddittionalConfigurationComponent;
